module.exports = __webpack_public_path__ + "img/border7.684486b9.png";